import type { FC } from 'react';

export const FirefliesLogo: FC<{ className?: string }> = ({ className }) => (
  <div className={className ?? 'w-8 h-8 flex items-center justify-center'}>
    <img
      src="/fireflies-logo.png"
      alt="Fireflies"
      className="w-full h-full object-contain"
    />
  </div>
);
